var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from '@material-ui/core';
import { SpellIcon } from '@timeflies/app-ui';
import { TimeCounter, TimeGauge } from '@timeflies/time-gauge-panel';
import React from 'react';
import { FeedbackContainer, feedbackItemHeight } from './feedback-container';
export var FeedbackSpell = function (_a) {
    var spellRole = _a.spellRole, timeProps = __rest(_a, ["spellRole"]);
    return React.createElement(FeedbackContainer, { left: React.createElement(SpellIcon, { spellRole: spellRole, size: feedbackItemHeight, padding: 2 }), right: React.createElement(Box, { mr: 0.5 },
            React.createElement(TimeCounter, __assign({}, timeProps))), bottom: React.createElement(Box, { width: '100%', p: 0.25 },
            React.createElement(TimeGauge, __assign({}, timeProps))) });
};
